module.exports = __parcel__import__.meta.resolve("7tG6Q");